import type { Locale } from '@atlassian/jira-common-constants/src/supported-locales';
import type { State } from '../../types';

export const appPropsSelector = (state: State) => state.appProps;

/** @deprecated baseUrl in cloud is an empty string. remove code that checks or uses it. */
export const baseUrlSelector = (_: unknown): string => '';
export const projectKeySelector = (state: State) => appPropsSelector(state).projectKey;
export const projectNameSelector = (state: State) => appPropsSelector(state).projectName;
export const getLocale = (state: State): Locale => appPropsSelector(state).locale;
export const isProjectSimplifiedSelector = (state: State) =>
	appPropsSelector(state).isProjectSimplified;
